import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    return (
        <>
            <div className="card-box card-box8 card-box-bottom">
                <EfIcon className="card-icon" pc="https://websiteoss.ecoflow.com/upload/image/1723725240464/b2.png" />
                <div className="card-desc">{t('item8_title')}</div>
            </div>
        </>
    );
}
